import { UniqueSeriesType } from '../../webservices/efc/utils/getSeriesV1UniqueSeries';

const getLabelFromSeriesMap = (series: string, seriesMap: UniqueSeriesType[]) => {
  const found = seriesMap.find(item => item.code === series);
  return found?.title || series;
};

export default getLabelFromSeriesMap;
